export enum ServiceAccountsCreateErrors {
  TOO_SHORT = 'TOO_SHORT',
  TOO_LONG = 'TOO_LONG',
  REQUIRED = 'REQUIRED',
  INVALID_CHARACTERS = 'INVALID_CHARACTERS',
  TAKEN = 'TAKEN',
  DEACTIVATED = 'DEACTIVATED',
  UNKNOWN = 'UNKNOWN',
}
